import EmbeddedWidgetsPage from './EmbeddedWidgetsPage';
export default EmbeddedWidgetsPage;
